'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$105() {
  this.bdA = null;
  this.bdB = false;
}
export { $c_Lpresto_PrestoRouter$$anon$105 as $c_Lpresto_PrestoRouter$$anon$105 };
$p = $c_Lpresto_PrestoRouter$$anon$105.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$105;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$105() {
}
export { $h_Lpresto_PrestoRouter$$anon$105 as $h_Lpresto_PrestoRouter$$anon$105 };
$h_Lpresto_PrestoRouter$$anon$105.prototype = $p;
$p.P = (function() {
  if ((!this.bdB)) {
    this.bdA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bdB = true;
  }
  return this.bdA;
});
var $d_Lpresto_PrestoRouter$$anon$105 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$105, "presto.PrestoRouter$$anon$105", ({
  Ns: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$105 as $d_Lpresto_PrestoRouter$$anon$105 };
//# sourceMappingURL=presto.-Presto-Router$$anon$105.js.map
